import CityPageTemplate from "../city-template/CityPageTemplate";
import { oceanCityConfig } from "./data";

export default function OceanCityPage() {
  return <CityPageTemplate config={oceanCityConfig} />;
}